/**
 *  EDAP events
 */

const actionlocation = 'recent-traveler-activity-module';

export const RECENTACTIVITY_VIEW = ({ listingid, eventlbsuuid }) => ({
  name: 'recentactivity.view',
  data: {
    actionlocation,
    listingid,
    eventlbsuuid
  }
});

export const NAV_PREVIOUS_CLICK = {
  name: 'nav.previous.click',
  data: {
    actionlocation
  }
};

export const NAV_NEXT_CLICK = {
  name: 'nav.next.click',
  data: {
    actionlocation
  }
};

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};
